import styled from "styled-components";

export interface CookieContentProps {
    title: string;
    link: string;
    items: CookieItemProps[];
}

export interface CookieItemProps {
    title: string;
    description: string;
    expiry: {
        label: string;
        value: string;
    };
    type: {
        label: string;
        value: string;
    };
}

export const ContentContainer = styled.div`
  padding-bottom: 8px;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const ContentTitle = styled.h3<{ active: boolean }>`
  color: ${({ active }) => (active ? "#7cc242" : "#323330")};
  font-size: 16px;
  line-height: 18px;
  font-weight: 700;
  margin: 0 0 0 12px;
  font-family: var(--branding-font), sans-serif;
  padding: 0;
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ContentFlexCenter = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ active }) => (active ? "#7cc242" : "#323330")};
  font-size: 12px;
  cursor: pointer;
`;

export const ContentCount = styled.div<{ active: boolean }>`
  color: ${({ active }) => (active ? "#7cc242" : "#323330")};
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: 2px 8px;
  background-color: #e0e3dd;
  border-radius: 10px;
  margin-left: 8px;
`;

export const ContentParagraph = styled.p`
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: #626560;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const ContentProviders = styled.div<{ active: boolean; count: number }>`
  overflow: hidden;
  transition: 0.4s max-height;
  ${({ active, count }) => (active ? `` : "max-height: 0;")};
  margin-bottom: ${({active}) => active ? '16px' : 0};
`;
